import { gql } from "@apollo/client";

export const GET_WATER_LEAK_DETECTION_SCORE_QUERY = gql`
  query GetWaterLeakDetectionScore($companyId: ID) {
    getWaterLeakDetectionScore(companyId: $companyId) {
      overallScore
      rating
      riskLevel
      complianceScore
      obligations {
        obligationId
        obligation
        type
        status
        standardKeys
        consequenceOfBreach
      }
      categories {
        key
        name
        weightPct
        score
        weightedContribution
        dataSource
        summary
        metrics {
          label
          value
          target
          unit
        }
      }
      buildings {
        buildingId
        buildingName
        squareFootage
        overallScore
        riskLevel
        categories {
          key
          name
          weightPct
          score
          weightedContribution
          dataSource
          summary
          metrics {
            label
            value
            target
            unit
          }
        }
        criticalAssetGaps {
          entityType
          entityId
          entityName
          reason
          category
        }
        occupancyGaps {
          entityType
          entityId
          entityName
          reason
          category
        }
      }
    }
  }
`;

export const GET_WATER_LEAK_ISOLATION_SCORE_QUERY = gql`
  query GetWaterLeakIsolationScore($companyId: ID) {
    getWaterLeakIsolationScore(companyId: $companyId) {
      overallScore
      rating
      riskLevel
      complianceScore
      obligations {
        obligationId
        obligation
        type
        status
        standardKeys
        consequenceOfBreach
      }
      categories {
        key
        name
        weightPct
        score
        weightedContribution
        dataSource
        summary
        metrics {
          label
          value
          target
          unit
        }
      }
      buildings {
        buildingId
        buildingName
        squareFootage
        overallScore
        riskLevel
        categories {
          key
          name
          weightPct
          score
          weightedContribution
          dataSource
          summary
          metrics {
            label
            value
            target
            unit
          }
        }
        floorValveGaps {
          entityType
          entityId
          entityName
          reason
          category
        }
        criticalZoneGaps {
          entityType
          entityId
          entityName
          reason
          category
        }
        buildingValveGaps {
          entityType
          entityId
          entityName
          reason
          category
        }
      }
    }
  }
`;

export const GET_WATER_CONTAINMENT_REPORT_QUERY = gql`
  query GetWaterContainmentReport($buildingId: ID, $companyId: ID) {
    getWaterContainmentReport(buildingId: $buildingId, companyId: $companyId) {
      buildingId
      buildingName
      address
      reportDate
      overallScore
      rating
      riskLevel
      standards
      pillars {
        key
        name
        weightPct
        complianceScore
        geometricScore
        pillarScore
        geometricRisk
        totalObligations
        passed
        failed
        pending
        noResult
        rating
      }
      standardsCompliance
      jurisdictionMatrix
      assetCoverage
      findings
      correctiveActions
      evidence {
        totalResults
        withDocument
        completenessPct
      }
      assetRelations
      relationshipSummary
      detectionGaps
      isolationGaps
    }
  }
`;

export const GET_WATER_CONTAINMENT_METRIC_WEIGHTAGES_QUERY = gql`
  query GetWaterContainmentMetricWeightages($companyId: ID) {
    getWaterContainmentMetricWeightages(companyId: $companyId) {
      pillars {
        pillar
        metrics {
          key
          label
          weightPct
        }
      }
    }
  }
`;

export const UPDATE_WATER_CONTAINMENT_METRIC_WEIGHTAGES_MUTATION = gql`
  mutation UpdateWaterContainmentMetricWeightages(
    $companyId: ID
    $pillars: [WaterContainmentMetricWeightPillarInput!]!
  ) {
    updateWaterContainmentMetricWeightages(
      companyId: $companyId
      pillars: $pillars
    ) {
      success
      message
    }
  }
`;

export const GET_LENS_ASSET_SCORES_QUERY = gql`
  query GetLensAssetScores($lensKey: String!, $limit: Int, $offset: Int) {
    getLensAssetScores(lensKey: $lensKey, limit: $limit, offset: $offset) {
      totalCount
      assets {
        assetId
        assetName
        score
        fieldScore
        evidenceScore
        locationScore
        connectionScore
        locationName
        locationAddress
      }
    }
  }
`;

export const GET_LENS_LOCATION_SCORES_QUERY = gql`
  query GetLensLocationScores($lensKey: String!) {
    getLensLocationScores(lensKey: $lensKey) {
      lensKey
      totalCount
      locations {
        locationId
        locationName
        locationAddress
        score
        assetCount
      }
    }
  }
`;

export const GET_LENS_ASSET_DRILLDOWN_QUERY = gql`
  query GetLensAssetDrilldown($assetId: ID!, $lensKey: String!) {
    getLensAssetDrilldown(assetId: $assetId, lensKey: $lensKey) {
      assetId
      lensKey
      unfilledSpecifications {
        key
        label
        required
        weight
      }
      missingEvidence {
        promptId
        promptName
        required
        weight
        assetId
        uploadDocumentsPath
      }
      otherIncompleteDetails
    }
  }
`;

export const GET_LENS_EVIDENCE_DRILLDOWN_QUERY = gql`
  query GetLensEvidenceDrilldown($lensKey: String!, $assetIds: [ID!]) {
    getLensEvidenceDrilldown(lensKey: $lensKey, assetIds: $assetIds) {
      lensKey
      missingByAsset {
        assetId
        lensKey
        missingEvidence {
          promptId
          promptName
          required
          weight
          assetId
          uploadDocumentsPath
        }
      }
    }
  }
`;

// Asset Timeline / Lifecycle Activity Feed
